import React from 'react'
import { formatDeviation, DEVIATION_LATE_COLOR } from '../utils/deviation'

/**
 * Story 100 (S101/S102, RN39 + DN-6/DN-18): renders the widget's single deviation cell -- days and
 * hours with sign, highlighted in red when it represents a delay (closed deviation late, or an
 * in-progress one past its promised deadline: both are positive minutes, so the same highlight
 * applies uniformly, RN41). Blank when `minutes` is `null`/`undefined` (never a "0").
 *
 * @param {Object} props
 * @param {number} [props.minutes] - signed deviation, in minutes
 */
const DeviationCell = ({ minutes }) => {
  const { text, isLate } = formatDeviation(minutes)
  return (
    <span data-testid='deviation-value' style={isLate ? { color: DEVIATION_LATE_COLOR, fontWeight: 'bold' } : undefined}>
      {text}
    </span>
  )
}

export default DeviationCell
